export default __webpack_public_path__ + "static/media/217.4bb73add.png";